import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { googleStaffAuth } from '../../utils/googleStaffAuth';
import type { SessionUser } from '../../utils/session';

export default function GoogleStaffSignIn({ onLogin }: { onLogin: (token: string, user?: SessionUser) => void }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [pending, setPending] = useState(false);
  const signIn = async () => {
    setBusy(true); setError(''); setPending(false);
    try {
      const result = await googleStaffAuth('/auth/google/start');
      if (result.status === 'pending') { setPending(true); return; }
      if (!result.token) throw new Error('googleAuthorizationFailed');
      onLogin(result.token, result.user);
    } catch (e) { setError(e instanceof Error ? e.message : 'googleAuthorizationFailed'); }
    finally { setBusy(false); }
  };
  return <section style={{ margin: '20px 0', color: '#172554' }}>
    <button type="button" data-testid="google-sign-in" onClick={signIn} disabled={busy} style={{ width: '100%', padding: 14, borderRadius: 12, border: '1px solid #64748b', background: '#fff', color: '#172554', fontSize: 16, fontWeight: 600, cursor: busy ? 'not-allowed' : 'pointer' }}>
      {t(busy ? 'staff.working' : 'staff.signInGoogle')}
    </button>
    {pending && <p role="status" style={{ marginTop: 16, padding: '12px 16px', borderRadius: 12, background: '#fef3c7', color: '#92400e', textAlign: 'center' }}>{t('staff.pendingApproval')}</p>}
    {error && <p role="alert" style={{ marginTop: 16, padding: '12px 16px', borderRadius: 12, background: '#fee2e2', color: '#b91c1c', textAlign: 'center' }}>{t(`staff.errors.${error}`, { defaultValue: t('staff.errors.googleAuthorizationFailed') })}</p>}
  </section>;
}
